import { yleConsentSdkHeadless } from '@yleisradio/consent-sdk/headless';
import { MutableConsentName } from '../appTypings';

export const getMutableConsentNames = (
  isLoggedIn: boolean
): MutableConsentName[] => {
  if (isLoggedIn) {
    return ['development', 'embedded_social_media'];
  }

  return ['development'];
};

export function getCurrentConsent(isLoggedIn: boolean) {
  const consentObject = yleConsentSdkHeadless.getConsent();

  return getMutableConsentNames(isLoggedIn).reduce(
    (selections, consent) => ({
      ...selections,
      [consent]: consentObject[consent],
    }),
    {} as Record<MutableConsentName, boolean>
  );
}
